// Renseigne « France » sur les établissements créés sans pays : le champ pays du formulaire
// « Établissement » est masqué, sa valeur par défaut n'était donc jamais envoyée
// (Shelter.beforeSave le renseigne désormais à l'enregistrement).

async function applyJob() {
    const result = await global.app.C.Shelter.collection.updateMany(
        {$or: [{country: {$exists: false}}, {country: null}, {country: ''}]},
        {$set: {country: 'France'}}
    )
    return {message: `${result.modifiedCount} établissement(s) sans pays passé(s) à « France »`}
}

export const job = {
    name: "adaptShelterCountries",
    title: "Renseigner le pays « France » sur les établissements sans pays",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
